module.exports = __webpack_public_path__ + "static/media/clear.e02aebfc.png";